import {usePageTitle} from "_hooks";
import {Card, Nav, Tab} from "react-bootstrap";
import {Link} from "react-router-dom";
import {Details} from "../Details";
import {Security} from "../Security";

const ProfileTab = () => {
    usePageTitle({title: 'Perfil - Detalhes', breadCrumbItems: []});

    return (
        <Card>
            <Card.Body className='p-0'>
                <Tab.Container defaultActiveKey="details">
                    <Nav as="ul" variant="tabs" justify className="nav-bordered">

                        <Nav.Item as="li">
                            <Nav.Link as={Link} to="#" eventKey='details' className="cursor-pointer">
                                Detalhes
                            </Nav.Link>
                        </Nav.Item>

                        <Nav.Item as="li">
                            <Nav.Link as={Link} to="#" eventKey='security' className="cursor-pointer">
                                Segurança
                            </Nav.Link>
                        </Nav.Item>

                    </Nav>

                    <Tab.Content className='p-3'>

                        <Tab.Pane eventKey='details' id="3">
                            <Details />
                        </Tab.Pane>

                        <Tab.Pane eventKey='security' id="4">
                            <Security />
                        </Tab.Pane>

                    </Tab.Content>
                </Tab.Container>
            </Card.Body>
        </Card>
    );
}
export default ProfileTab;
